import { render, staticRenderFns } from "./deviceSettings.vue?vue&type=template&id=53097b4c&scoped=true&"
import script from "./deviceSettings.vue?vue&type=script&lang=js&"
export * from "./deviceSettings.vue?vue&type=script&lang=js&"
import style0 from "./deviceSettings.vue?vue&type=style&index=0&id=53097b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53097b4c",
  null
  
)

export default component.exports